import { Stack, StackProps, styled } from '@mui/material'

export const StyledStackRow = styled(({ children, ...props }: StackProps) => (
  <Stack direction="row" spacing={1} {...props}>
    {children}
  </Stack>
))({
  alignItems: 'center',
})
